import { Box, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react";
import SwitchToggle from "../../components/SwitchToggle";
import AddTemplate from "../../Modals/addtemplate";

const ViewFieldTemplates = () => {
    const navigate=useNavigate();
    const [searchTerm, setSearchTerm] = useState("");
    const [openTemplateModal, setOpenTemplateModal] = useState(false);
    const handleCloseModal1 = () => {
        setOpenTemplateModal(false);
    };

    return (
        <>
            <div className="main_title">
                <h1>View Field Templates </h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  
                    <button onClick={() => navigate("/manage-system-settings")}>Settings</button> - View Field Templates 
                </p>
            </div>
            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search Campaign..."
                            />
                        </Box>
                    </div>

                    <div className="right_s">
                        <Button className="btn btn_primary" onClick={() => setOpenTemplateModal(true)}>
                            <AddIcon /> Add
                        </Button>
                    </div>
                </div>

                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow hover>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Template Name</TableCell>
                                <TableCell>Created Date</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {[
                                {
                                    id: 1,
                                    fieldName: "Store Bio",
                                    templateName: "Crafted With AI",
                                    createdDate: "05 Jan 2025",
                                    status: true,
                                },
                                {
                                    id: 2,
                                    fieldName: "Store Motto",
                                    templateName: "Made in UAE",
                                    createdDate: "12 Jan 2025",
                                    status: false,
                                },
                                {
                                    id: 3,
                                    fieldName: "Store Information",
                                    templateName: "Inspired by UAE heritage",
                                    createdDate: "20 Jan 2025",
                                    status: true,
                                },
                            ].map((row, idx) => (
                                <TableRow hover key={row.id}>
                                    <TableCell>{idx + 1}</TableCell>


                                    <TableCell>{row.templateName}</TableCell>

                                    <TableCell>{row.createdDate}</TableCell>

                                    {/* Status Toggle */}
                                    <TableCell>
                                        <SwitchToggle />
                                    </TableCell>

                                    {/* Delete Action */}
                                    <TableCell>
                                        <IconButton>
                                            <img src="/static/images/trash2_icon.svg" alt="delete" />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>


                </TableContainer>
            </div>
            <AddTemplate
                open={openTemplateModal}
                onClose={handleCloseModal1}
                setOpen={setOpenTemplateModal}
            />
        </>
    );
}
export default ViewFieldTemplates;